import React from 'react';
import { RightOutlined } from '@ant-design/icons';
import { Row, Col } from 'antd';
import { StyledTitle as Title } from '../../fields/Title';
import LaptopImage from '../../../assets/Laptop.png';
import LearningImage from '../../../assets/learning.svg';
import AccessibleImage from '../../../assets/accessible.svg';
import GlobeImage from '../../../assets/globe.svg';
import { StyledButton } from '../../../styles/StyledComponents';
import { FormattedMessage } from 'react-intl';

export const WhyParents = () => {
  return (
    <>
      <Row justify='center'>
        <Col
          xl={20}
          sm={22}
          style={{
            background: '#fff',
            padding: 40,
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
          }}
        >
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 40 }}>
            {/* LEFT COLUMN */}
            <Col xl={12}>
              <img src={LaptopImage} alt='' />
              {/* <img src={PhoneImage} style={{width: 400, margin: '0 auto', display: 'block'}} alt="" /> */}
            </Col>
            {/* RIGHT COLUMN */}
            <Col xl={12}>
              <Title level={2} style={{ color: '#333', fontWeight: 'bolder' }}>
                <FormattedMessage id='why-tutorD.title' />
              </Title>
              <br />
              <strong style={{ color: '#333' }}>
                <FormattedMessage id='why-tutorD.subTitle' />
              </strong>
              <br />
              <br />
              <p>
                <FormattedMessage id='parents-header.main.description' />
              </p>
              <br />
              <StyledButton style={{ borderRadius: 6, height: 40, width: 150 }}>
                <FormattedMessage id='parents-header.main.about-us-link' /> <RightOutlined />
              </StyledButton>
            </Col>
          </Row>
          {/* PURPLE CONTAINER */}
          <Row justify='center' style={{ margin: '40px 0' }}>
            <Col
              xl={24}
              style={{
                background: '#8053D7',
                borderRadius: 6,
                filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
                padding: 40
              }}
            >
              <p
                style={{
                  fontSize: '2.5em',
                  fontFamily: 'Montserrat Bold',
                  color: '#fff',
                  textAlign: 'center'
                }}
              >
                <FormattedMessage id='parents-header.main.whole-student.title' />
                <span style={{ color: '#FFDC54' }}><FormattedMessage id='parents-header.main.whole-student.title-link' />.</span>
              </p>
              <p style={{ color: '#fff', textAlign: 'center' }}>
                <FormattedMessage id='parents-header.main.whole-student.description' />
              </p>
            </Col>
          </Row>
          {/* 3 ROW COLUMN */}
          <Row justify='center' gutter={[40, 40]} style={{ textAlign: 'center' }}>
            <Col xl={8}>
              <img src={AccessibleImage} alt='' style={{ height: 200 }} />
              <br />
              <br />
              <Title level={3} style={{ color: '#333' }}>
                <FormattedMessage id='parents-header.main.whole-student.subtitleOne' />
              </Title>
              <p style={{ color: '#333' }}>
                <FormattedMessage id='parents-header.main.whole-student.descriptionOne' />
              </p>
            </Col>
            <Col xl={8}>
              <img src={GlobeImage} alt='' style={{ height: 200 }} />
              <br />
              <br />
              <Title level={3} style={{ color: '#333' }}>
                <FormattedMessage id='parents-header.main.whole-student.subtitleTwo' />
              </Title>
              <p style={{ color: '#333' }}>
                <FormattedMessage id='parents-header.main.whole-student.descriptionTwo' />
              </p>
            </Col>
            <Col xl={8}>
              <img src={LearningImage} alt='' style={{ height: 200 }} />
              <br />
              <br />
              <Title level={3} style={{ color: '#333' }}>
                <FormattedMessage id='parents-header.main.whole-student.subtitleThree' />
              </Title>
              <p style={{ color: '#333' }}>
                <FormattedMessage id='parents-header.main.whole-student.descriptionThree' />
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
